<script>
export default {
  props: {
    yearLabel: {
      type: String,
    },
    monthLabel: {
      type: String,
    },
    years: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    isHighlighted: {
      type: Boolean,
      default: false,
    },
    months: {
      type: Array,
      required: true,
    },    
  },
  computed: {
    monthOptions() {
      return this.months
    },
    month: {
      get() {
        if (!this.value.month) return null;
        return this.value.month;
      },
      set(value) {
        this.$emit("changeMonth", value);
        this.$emit("input", { ...this.value, month: value });
      },
    },
    year: {
      get() {
        if (!this.value.year) return null;
        return this.value.year;
      },
      set(value) {
        this.$emit("changeYear", value);
        this.$emit("input", { ...this.value, year: value });
      },
    },
  },
};
</script>

<template>
  <div class="year-and-month-input__container" :class="isHighlighted ? 'year-and-month-input--highlighted' : ''">
    <div class="year-and-month-input__input">
      <span class="year-and-month-input__input-title">
        {{ yearLabel }}
      </span>
      <b-button-group>
        <b-button
          v-for="iterationYear in years"
          :key="iterationYear"
          :variant="`${iterationYear === year ? 'primary' : 'outline-primary'}`"
          @click="year = iterationYear"
          >{{ iterationYear }}
        </b-button>
      </b-button-group>
    </div>

    <div class="year-and-month-input__input">
      <span class="year-and-month-input__input-title">{{ monthLabel }}</span>
      <b-form-select 
        :options="months" 
        v-model="month"
        :disabled="!year"
    ></b-form-select>
    </div>
  </div>
</template>

<style scoped lang="scss">
    .year-and-month-input__container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .year-and-month-input__input { 
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .year-and-month-input__input-title {
        font-weight: bold;
    }

    .year-and-month-input__container .btn-group .btn-primary {
        background-color: #00184D;
        color: #fff;
    }

    .year-and-month-input__container .btn-group .btn-outline-primary {
        border-color: #00184D;
        color: #00184D;

        &:hover {
          color: #fff;
        }
    }
</style>